import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useTable, usePagination, useSortBy } from 'react-table'
import Map, { Source, Layer } from 'react-map-gl';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import dayjs from 'dayjs';
import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";

import LoadProfileChart from '../components/D3/LoadProfileChart.js';

import styled from 'styled-components'

import {
  getProfilChargeCarte, getAllAgencies, getRoutes,
  getProfilChargeGraph, getChargeTrips, getUser,
  getUserAgency
} from '../API';

import { orderStops } from '../helpers/orderStops.js';

import optc from '../optc.json'

import ReactLoading from 'react-loading';

import { useTranslation } from "react-i18next";

const Styles = styled.div

  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  td { background-color: white; }
  td:nth-child(1) { 
    background: #79508f ;
    color: white }
  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },
    },
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }


  // Render the UI for your table
  return (


    <>
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Départ' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")}{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}



function ChargeTrip() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const columns = useMemo(
    () => [
      {
        Header: t('tripocc.table.trip'),
        accessor: 'trip_id',
        Cell: props => <div style={{ cursor: 'pointer' }} onClick={(e) => handleTripClick(e)}>{props.value}</div>,
      },
      {
        Header: t('tripocc.table.route'),
        accessor: 'route_id',
      },
      {
        Header: 'Direction',
        accessor: 'direction_id',
      },
      {
        Header: t('tripocc.table.start'),
        accessor: 'tripstart',
        Cell: props => <div> {new Date(props.value * 1000).toISOString().substring(11, 16)} </div>
      },
      {
        Header: t('tripocc.table.occ'),
        accessor: 'avg',
        Cell: props => <div> {parseFloat(props.value).toFixed(1)} </div>
      },
      {
        Header: t('tripocc.table.sample'),
        accessor: 'occurences'
      },
    ],
    []
  )

  const [loading, setLoading] = useState(0);

  const [user, setUser] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');

  const [mapIsLoaded, setMapIsLoaded] = useState(false);
  const [charge, setCharge] = useState({ "type": "FeatureCollection", "features": [] });
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState('');
  const [trips, setTrips] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState('');
  const [direction, setDirection] = useState(1);
  const [service, setService] = useState("SE");
  const [chargeGraph, setChargeGraph] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(0);

  const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 1));
  const [endDate, setEndDate] = useState(null);
  const [startFormat, setStartFormat] = useState(dayjs().add(-8, 'day').format('YYYY-MM-DD'));
  const [endFormat, setEndFormat] = useState(dayjs().add(-1, 'day').format('YYYY-MM-DD'));
  const [allDates, setAllDates] = useState(0);

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey3, setRefreshKey3] = useState(0);

  const mapRef = useRef();

  useEffect(() => {
    setLoading(1);
    getAllAgencies()
      .then(response => {
        setAgencies(response);
        getRoutes(agency)
          .then(response => {
            setRoutes(response);
            setSelectedRoute(response[0].route_id);
            setLoading(0);
          });
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency().then(response => {
      setUserAgency(response)
    })
  }, [refreshKey]);

  useEffect(() => {
    setLoading(1);
    getChargeTrips(agency, selectedRoute, service, direction, startFormat, endFormat)
      .then(response => {
        setTrips(response);
        setLoading(0);
      });
  }, [refreshKey1]);

  useEffect(() => {
    if (selectedTrip !== '') {
      setLoading(1);
      Promise.all([
        getProfilChargeCarte(agency, selectedTrip),
        getProfilChargeGraph(agency, selectedTrip)
      ])
        .then(([
          carteResponse,
          graphResponse
        ]) => {
          setCharge(carteResponse[0].jsonb_build_object);
          setChargeGraph(graphResponse[0].days_stops);
          setDataLoaded(1);
          setLoading(0);
        })
    }
  }, [refreshKey2]);

  useEffect(() => {
    zoomToLocation();
  }, [refreshKey3])

  const handleAgencySelect = (e) => {
    setAgency(e.target.value);
    setDataLoaded(0);
    setChargeGraph([]);
    setTrips([]);
    setCharge({ "type": "FeatureCollection", "features": [] });
    setRefreshKey(oldKey => oldKey + 1);
    setRefreshKey3(oldKey => oldKey + 1);
  }

  const handleRouteSelect = (e) => {
    setSelectedTrip('');
    setCharge({ "type": "FeatureCollection", "features": [] });
    setSelectedRoute(e.target ? e.target.value : e);
    setRefreshKey1(oldKey => oldKey + 1);
    setRefreshKey3(oldKey => oldKey + 1);
  }

  const handleServiceClick = (e) => {
    if (e.target.innerHTML == t('dailyotp.week')) {
      setService("SE")
    } else if (e.target.innerHTML == t('dailyotp.sat')) {
      setService("SA")
    } else {
      setService("DI")
    }
    //setRefreshKey(oldKey => oldKey + 1);
    setRefreshKey1(oldKey => oldKey + 1);
  }

  const handleDirectionClick = (e) => {
    if (e.target.innerHTML == t('tripotp.out')) {
      setDirection(1)
    } else {
      setDirection(0)
    }
    setRefreshKey1(oldKey => oldKey + 1);
  }

  const handleTripClick = (e) => {
    setSelectedTrip(e.target.innerHTML);
    setRefreshKey2(oldKey => oldKey + 1);
    setRefreshKey3(oldKey => oldKey + 1);
  }

  const handleOnLoad = () => {
    setMapIsLoaded(true);
  }

  const handleChangeDate = (dates) => {

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (end !== null) {
      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');
      setStartFormat(formatstart);
      setEndFormat(formatend);
      setAllDates(0);
      setRefreshKey1(oldKey => oldKey + 1);
      setRefreshKey2(oldKey => oldKey + 1);
    }

  };

  const handleDateInit = () => {

    setStartDate(new Date().setDate(new Date().getDate() - 1));
    setEndDate(null);
    setStartFormat('');
    setEndFormat('');
    setAllDates(1);
    setRefreshKey1(oldKey => oldKey + 1);

  };

  const zoomToLocation = () => {

    if (mapIsLoaded == true && agency == '') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[1],
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[0]
        ], duration: 2000
      });
    } else if (mapIsLoaded == true && agency !== '') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == agency).latlong[1],
          optc.optc.find((e) => e.operateur == agency).latlong[0]
        ], duration: 2000
      });
    }
  }


  return (

    user && userAgency && routes ?

      <>

        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm">
            <h1 id="page-title" className="display-5">{t('tripocc.title')}</h1>
            {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
              <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
            </div> : ''}
          </div>
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="row justify-content-center pt-3">
            <div className="col-lg col-sm-12 text-center">
              <div className="me-1 border rounded ps-2 pe-2 pb-2" style={{ backgroundColor: "white" }}>

                <div className="row text-center pt-3 pb-2">

                  <DatePicker
                    selected={startDate}
                    onChange={handleChangeDate}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    inline
                    locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
                    excludeDateIntervals={[
                      {
                        start: subDays(new Date('2000-01-01'), 0),
                        end: addDays(new Date('2023-07-01'), 0)
                      },
                      {
                        start: subDays(new Date(), 1),
                        end: addDays(new Date('2030-12-31'), 0)
                      },
                    ]}
                  />
                </div>

                <div className="row justify-content-center">
                  <div className="col text-center pt-2 pb-2">
                    <h3>{(startFormat == endFormat)&&allDates!==1 ?
                      dayjs(startFormat).format('YYYY-MM-DD') :
                      allDates==1 ? t('tripotp.alldates') :
                      t('vehdays.from') + dayjs(startFormat).format('YYYY-MM-DD') + t('vehdays.to') + dayjs(endFormat).format('YYYY-MM-DD')}</h3>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col text-center pb-3">
                    <button type="button" className="btn btn-secondary"
                      onClick={handleDateInit}>{t('tripotp.alldates')}</button>
                  </div>
                </div>

                {loading == 0 ? '' :
                  <div className="ponctualitetripspinner">
                    <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
                  </div>}

                <div className="row justify-content-center align-items-center pt-3">

                  {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="col-lg-2">
                    <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>Opérateur</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div> : ''}

                  <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <select onChange={(event) => handleRouteSelect(event)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>Ligne</option>
                      {routes.map((e) => (
                        <option value={e.route_short_name} key={e.route_short_name}
                        >{e.route_short_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 text-center pb-2">
                    <div type="button" className={direction == 1 ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleDirectionClick(event)}>{t('tripotp.out')}</div>
                    <div type="button" className={direction == 0 ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleDirectionClick(event)}>{t('tripotp.in')}</div>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 text-center pb-2">
                    <div type="button" className={service == "SE" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.week')}</div>
                    <div type="button" className={service == "SA" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sat')}</div>
                    <div type="button" className={service == "DI" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                      onClick={(event) => handleServiceClick(event)}>{t('dailyotp.sun')}</div>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <div className="row justify-content-center pt-3 pb-3">
            <div className="col-lg col-sm-12 text-center pt-2">
              <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                <div id="overflow-table" className="container">
                  <div className="row justify-content-center">
                    <div className="col">
                      <Styles>
                        <Table columns={columns} data={trips} />
                      </Styles>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedTrip && trips.length > 0 ?
            <div className="row justify-content-center pt-2 pb-4">
              <div className="col-lg col-sm-12 pt-3">
                <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>
                  <div style={{ width: '100%', height: '400px' }}>
                    <LoadProfileChart
                      data={chargeGraph}
                      selectedTrip={dataLoaded == 1 ? new Date(chargeGraph[0].start_time * 1000).toISOString().substring(11, 16) : selectedTrip}
                      color={agency == '' ? optc.optc.find((f) => f.operateur == userAgency[0]).color :
                        optc.optc.find((f) => f.operateur == agency).color}
                    />
                  </div>
                </div>
              </div>
            </div> : ''}


          <div className="row justify-content-center pt-3">
            <div className="col-lg-12 col-sm-12 pt-3 pb-4">
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                <Map
                  initialViewState={{
                    latitude: 45.556827,
                    longitude: -73.662362,
                    zoom: 9
                  }}
                  style={{ width: '100%', height: '40vh' }}
                  ref={ref => mapRef.current = ref && ref.getMap()}
                  onLoad={handleOnLoad}
                  mapStyle="mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k"
                  mapboxAccessToken={process.env.REACT_APP_MAPBOX_KEY}
                  interactiveLayerIds={charge.features.map((g) => {
                    return "segment-layer-" + g.properties.segment
                  })}
                  attributionControl={false}
                >
                  {charge.features.map(g => (
                    <Source
                      key={"segment-" + g.properties.segment}
                      id={"segment" + g.properties.segment}
                      type="geojson" data={g}
                    >
                      <Layer {...{
                        "id": "segment-layer-" + g.properties.segment,
                        'type': 'line',
                        "source": "segment" + g.properties.segment,
                        "layout": {
                          "line-join": "round",
                          "line-cap": "round",
                          "visibility": "visible"
                        },
                        "paint": {
                          'line-width': ['get', 'charge'],
                          'line-color': agency == '' ?
                            optc.optc.find((e) => e.operateur == userAgency[0]).color :
                            optc.optc.find((e) => e.operateur == agency).color
                        }
                      }} />
                    </Source>
                  ))}
                </Map>
              </div>
            </div>
          </div>

        </div >

      </>
      :
      <>
        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex justify-content-center">
            <div className="row">
              <div className="col-sm">
                <h1 className="display-5">{t('data.loading')}</h1>
                <div className="d-flex justify-content-center">
                  <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

  )
}

export default ChargeTrip;